import SegmentedSelect from './SegmentedSelect'
export default SegmentedSelect
